import { TableSearchBar } from 'components/tables/TableSearchBar';
import { useGroupsStore } from 'pages/admin-dashboard/groups/store';
import styled from 'styled-components';

export const GroupsTableToolbar = () => {
  const { setPageNumber, name, setName } = useGroupsStore();
  return (
    <ToolbarContainer>
      <TableSearchBar
        value={name}
        onChange={setName}
        resetPage={() => setPageNumber(1)}
        placeholder="Search groups by name..."
      />
    </ToolbarContainer>
  );
};

const ToolbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1em;
  align-items: center;
`;
